export default {
  // banner底部数据
  bannerBottomData: [
    {
      firstLineText: '19年+',
      secondLineText: '服务经验',
    },
    {
      firstLineText: '502万+',
      secondLineText: '企业服务',
    },
    {
      firstLineText: '2.7亿+',
      secondLineText: '个人用户',
    },
    {
      firstLineText: '121亿+',
      secondLineText: '总签署量',
    },
    {
      firstLineText: '24x365小时',
      secondLineText: '管家式服务',
    },
  ],
  equityData: {
    title: '6.18专享权益',
    desc: '四大福利待领取，新购、升级、续费更划算',
    equityList: [{
      subTitle: '权益一',
      msg: ['流量', '份数', '赠送'],
      bold: '赠送',
      icon: require(`../../assets/images/sem618/msg1.png`)
    }, {
      subTitle: '权益二',
      msg: ['价格', '限时', '优惠'],
      bold: '限时',
      icon: require(`../../assets/images/sem618/msg2.png`)
    }, {
      subTitle: '权益三',
      msg: ['增值', '升级', '优惠'],
      bold: '优惠',
      icon: require(`../../assets/images/sem618/msg3.png`)
    }, {
      subTitle: '权益四',
      msg: ['用户', '服务', '升级'],
      bold: '升级',
      icon: require(`../../assets/images/sem618/msg4.png`)
    }],
  },
  productPower: {
    title: '产品升级/新品发布',
    powerList: [
      {
        name: '公有云SaaS平台',
        iconUrl: require(`../../assets/images/sem618/power1.png`),
        toWho: '适用对象：成长型中小企业',
        descList: [
          '超高性价比选择',
          '开通即用，功能丰富，签管一体',
          '智能AI与电子合同的完美结合',
          '一处发起，多处签署',
          '覆盖PC、微信、支付宝、APP等六大端',
        ],
        link: '免费试用',
        url: 'https://www.baidu.com',
      },
      {
        name: '公有云API开放平台',
        iconUrl: require(`../../assets/images/sem618/power2.png`),
        toWho: '适用对象：中大型企业组织',
        descList: [
          '快速集成OA/CRM/SCM/EHR/ERP 等原有业务系统',
          '参数自定义，性能强，商业模式灵活',
          '多种签署体验，覆盖全部行业场景应用',
          '多种对接方案，满足深度融合需求',
          '全程取证、司法机构广泛认可',
        ],
        link: '立即接入',
        url: 'https://www.baidu.com',
      },
      {
        name: '混合云印章平台',
        iconUrl: require(`../../assets/images/sem618/power3.png`),
        toWho: '适用对象：集团型企业',
        descList: [
          '科学中立的相对方模型',
          '原文沙箱专利技术，确保隐私安全',
          '私有化部署，核心数据不出网',
          '支持“国产化信创&国际通用” 双重环境规范',
          '物电一体，整合印控仪、电子印章一体化方案',
          '1000+大型组织信息化建设应用沉淀',
        ],
        link: '立即接入',
        url: 'https://www.baidu.com',
      },
      {
        name: '钉钉智能合同',
        iconUrl: require(`../../assets/images/sem618/power4.png`),
        toWho: '适用对象：钉钉平台企业用户',
        descList: ['钉钉原生电子签名官方应用', '与钉钉多项原生功能深度融合', '支持内/外部签署场景', '已服务钉钉平台百万级客户'],
        link: '免费试用',
        url: 'https://www.baidu.com',
      },
    ],
  },
  // 无需邮寄，1分钟完成线上签署
  flowPathOneLine: [
    {
      key: 1,
      imgSrc: require('@/assets/images/sem-saas/flow-one.png'),
      text: '实名认证',
    },
    {
      key: 2,
      imgSrc: require('@/assets/images/sem-saas/flow-two.png'),
      text: '申领印章',
    },
    {
      key: 3,
      imgSrc: require('@/assets/images/sem-saas/flow-three.png'),
      text: '线上签署',
    },
    {
      key: 4,
      imgSrc: require('@/assets/images/sem-saas/flow-four.png'),
      text: '发送合同',
    },
  ],
  flowPathTwoLine: [
    {
      key: 1,
      imgSrc: require('@/assets/images/sem-saas/flow-five.png'),
      text: '司法服务',
    },
    {
      key: 2,
      imgSrc: require('@/assets/images/sem-saas/flow-six.png'),
      text: '全流程上链',
    },
    {
      key: 3,
      imgSrc: require('@/assets/images/sem-saas/flow-seven.png'),
      text: '合同管理',
    },
    {
      key: 4,
      imgSrc: require('@/assets/images/sem-saas/flow-eight.png'),
      text: '对方签署',
    },
  ],

  solutions: {
    title: '行业实践解决方案',
    list: [
      {
        videoUrl: require('../../assets/video/human-resource.mp4'),
        imgUrl: require('../../assets/images/solution1.png'),
        link: '免费试用>',
        text: '人力资源',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/logistics.mp4'),
        imgUrl: require('../../assets/images/solution2.png'),
        link: '免费试用>',
        text: '物流',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/bank.mp4'),
        imgUrl: require('../../assets/images/solution3.png'),
        link: '免费试用>',
        text: '银行',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/car-leasing.mp4'),
        imgUrl: require('../../assets/images/solution4.png'),
        link: '免费试用>',
        text: '汽车',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/medical.mp4'),
        // imgUrl: require('../../assets/images/solution5.png'),
        imgUrl: require('../../assets/images/solution8.png'),
        link: '免费试用>',
        text: '医疗',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/construction.mp4'),
        // imgUrl: require('../../assets/images/solution6.png'),
        imgUrl: require('../../assets/images/solution7.png'),
        link: '免费试用>',
        text: '房地产',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/e-commerce.mp4'),
        // imgUrl: require('../../assets/images/solution7.png'),
        imgUrl: require('../../assets/images/solution6.png'),
        link: '免费试用>',
        text: 'B2B电商',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/online-education.mp4'),
        // imgUrl: require('../../assets/images/solution8.png'),
        imgUrl: require('../../assets/images/solution5.png'),
        link: '免费试用>',
        text: '在线教育',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
    ],
  },
  // 安全可靠的电子签章服务
  safeReliableData: [
    {
      img: require('@/assets/images/landing-semsign/system-one.png'),
      h5img: require('@/assets/images/landing-semsign/system-one-h5.png'),
      title: '一体化管理',
      desc: '实现电子签章、物理用印、存证与审签统一管理，助力企业半程无纸化向全程电子化过渡，使得合同签署流程更加顺畅、便捷。',
    },
    {
      img: require('@/assets/images/landing-semsign/system-two.png'),
      h5img: require('@/assets/images/landing-semsign/system-two-h5.png'),
      title: '极速部署',
      desc: '分钟级可视化极速部署，大幅度提升部署安装效能；99.9%的本地高可用部署方案，支持横向扩容提升性能。',
    },
    {
      img: require('@/assets/images/landing-semsign/system-three.png'),
      h5img: require('@/assets/images/landing-semsign/system-three-h5.png'),
      title: '安全可靠',
      desc:
        '文档隐私数据不出本地，原文沙箱快照技术保证混合云签署过程中的文档一致性，签署过程安全可靠 应用WAF安全防护模块，保证企业级应用访问安全。',
    },
    {
      img: require('@/assets/images/landing-semsign/system-four.png'),
      h5img: require('@/assets/images/landing-semsign/system-four-h5.png'),
      title: '国产化适配',
      desc:
        '信创名录电子签章指定供应商，提供流版签一体的国产化解决方案，完成市面上主流信创生态链的国产化适配，实现一套系统兼容标准/信创环境。',
    },
  ],
  // saas-ai
  saasAiData: [
    {
      key: 1,
      desc: '·【审批引擎】-内置多级审批引擎，拖曳式灵活配置',
    },
    {
      key: 2,
      desc: '·【合同比对】-AI智能比对能力，0.5秒在线比对OA审批终稿和用印文件',
    },
    {
      key: 3,
      desc: '·【智能台账】-企业合同智能化分类归档，智能获取业务数据自动形成业务台账',
    },
    {
      key: 4,
      desc: '·【信息采集】-合同签署前可灵活采集签署人信息，如身份证、学位证、家庭住址等',
    },
  ],
  orgList: {
    title: '客户案例',
    orgTypeList: ['人力资源', '地产租房', '互联网+', '银行金融', '零售制造', '汽车物流', '教育旅游'],
    imgs: ['humanRes', 'logistics', 'hlw', 'bank', 'lszz', 'qqwl', 'jjly'].map(item => {
      return require(`@/assets/images/${item}.png`)
    }),
  },
  numberInfo: {
    title: '签合同·用e签宝',
    btnText: '免费试用',
    numberList: ['63.27', '316.34', '5.27'],
    qrImgUrl: require(`../../assets/images/qr-code.png`),
  },
}
